const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class SubCollectionsBasic extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('sub-collections-basic')) {
  customElements.define('sub-collections-basic', SubCollectionsBasic)
}
